import React, { useContext, useEffect, useState } from "react";
import { Context } from "./index";
import Button from "../../common/Button";

import _ from "lodash";
import { Form, Formik } from "formik";
import TextBox from "../../common/TextBox";
import { ReactComponent as NoImagesSvg } from "../../../assets/newProject/no-images.svg";

const MaterialSelection = () => {
  const {
    images,
    selectedImageName,
    materialGroups,
    setMaterialGroups,
    closeOverlay,
    addNewPanoramaImage,
  } = useContext(Context);
  const [step, setStep] = useState(1);
  const [type, setType] = useState(undefined);
  const [currentType, setCurrentType] = useState(undefined);
  const [newImage, setNewImage] = useState(undefined);
  const [selectedSceneIndex, setSelectedSceneIndex] = useState(undefined);
  const [isAlreadyLinked] = useState(
    !!materialGroups.find((group) =>
      group.find((m) => m.to === selectedImageName)
    )
  );
  const [availableImages, setAvailableImages] = useState([]);

  useEffect(() => {
    setAvailableImages((_) => {
      let _availableImages = [];

      for (const image of images) {
        if (image.name === selectedImageName) continue;

        let linked = false;

        for (const mg of materialGroups) {
          if (mg.find((g) => g.to === image.name)) {
            linked = true;
            break;
          }
        }

        if (linked) continue;

        _availableImages.push(image);
      }

      return _availableImages;
    });
  }, []);

  const handleClose = () => {
    setType("");
    setCurrentType("");
    closeOverlay();
  };

  const handleImageClick = (imageIndex) => {
    setSelectedSceneIndex(imageIndex);
    setNewImage(undefined);
  };

  const handleReturnClick = () => {
    setNewImage(undefined);
    setStep(1);
  };

  const handleConfirmClick = () => {
    if (selectedSceneIndex === undefined && !newImage) {
      alert("Please select an image or upload new one!");
      return;
    }

    const _originImageName = selectedImageName;
    let _destinationImageName = null;

    // * Handle if select already existing image
    if (selectedSceneIndex !== undefined) {
      _destinationImageName = availableImages[selectedSceneIndex].name;
    }

    // * Handle new image
    if (newImage) {
      _destinationImageName = newImage.name;
      addNewPanoramaImage([newImage]);
    }

    setMaterialGroups((curr) => {
      // * Add new group if not exists
      if (!isAlreadyLinked)
        return [
          ...curr,
          [
            {
              type: currentType,
              to: _originImageName,
            },
            {
              type,
              to: _destinationImageName,
            },
          ],
        ];

      // * Add new material to existing group
      return curr.map((group) => {
        if (group.find((m) => m.to === _originImageName)) {
          return [
            ...group,
            {
              type,
              to: _destinationImageName,
            },
          ];
        }

        return group;
      });
    });

    handleClose();
  };

  const handleNewImageChanged = (e) => {
    if (!e.target.files || e.target.files.length === 0) return;

    setNewImage(e.target.files[0]);
    setSelectedSceneIndex(undefined);
  };

  const getRender = () => {
    if (step === 1) {
      return (
        <Formik
          initialValues={{ currentType, type }}
          enableReinitialize={true}
          validate={({ currentType, type }) => {
            let errors = {};

            if (!type) errors.type = "Please enter name for other material";

            // * Check only currentType
            if (isAlreadyLinked) {
              return errors;
            }

            if (!currentType)
              errors.currentType = "Please enter name for current material";

            return errors;
          }}
          onSubmit={(values) => {
            const { currentType, type } = values;

            setType(type);

            if (isAlreadyLinked) {
              setStep(2);
              return;
            }

            setCurrentType(currentType);
            setStep(2);
          }}
        >
          <Form className="new-project-hotspot-pannellum-materials-content-type">
            <div className="new-project-hotspot-pannellum-materials-content-type-cta">
              <Button
                label="Cancel"
                variant={"secondary"}
                onClick={handleClose}
              />
              <Button label="Continue" type="submit" />
            </div>
            {!isAlreadyLinked && (
              <TextBox
                label="Enter current scene material name"
                placeholder="Material name"
                name="currentType"
                autoComplete="off"
              />
            )}
            <TextBox
              label="Enter name for material"
              placeholder="Material name"
              name="type"
              autoComplete="off"
            />
          </Form>
        </Formik>
      );
    }

    if (step === 2) {
      return (
        <div className="new-project-hotspot-pannellum-materials-content-scenes">
          <div className="new-project-hotspot-pannellum-materials-content-scenes-header">
            <button
              className="new-project-hotspot-pannellum-materials-content-scenes-header__return"
              onClick={handleReturnClick}
            >
              {"Return"}
            </button>
            <button
              className="new-project-hotspot-pannellum-materials-content-scenes-header__return"
              onClick={handleConfirmClick}
            >
              {"Confirm"}
            </button>
          </div>
          {availableImages.length === 0 && !newImage && (
            <div className="new-project-hotspot-pannellum-materials-content-scenes__empty">
              <NoImagesSvg width={200} style={{ opacity: 0.7 }} />
              No panoramas left for linking
            </div>
          )}
          {availableImages.length > 0 && (
            <>
              <h3 className="new-project-hotspot-pannellum-materials-content-scenes__title">
                {"Select scene for material:"} {type}
              </h3>
              <div className="new-project-hotspot-pannellum-materials-content-scenes-gallery">
                {availableImages.map((image, index) => {
                  if (image.name === selectedImageName) return <></>;

                  // * Check if scene is already linked to any materials
                  if (
                    materialGroups.find((group) =>
                      group.find((m) => m.to === index)
                    )
                  )
                    return <></>;

                  const _className = [
                    "new-project-hotspot-pannellum-materials-content-scenes-gallery__image",
                  ];

                  if (selectedSceneIndex === index)
                    _className.push(
                      "new-project-hotspot-pannellum-materials-content-scenes-gallery__image--selected"
                    );

                  return (
                    <img
                      className={_className.join(" ")}
                      src={URL.createObjectURL(image)}
                      onClick={() => handleImageClick(index)}
                    />
                  );
                })}
              </div>
            </>
          )}
          <input
            id="new-project-hotspot-pannellum-materials-uploader"
            type="file"
            accept="image/*"
            onChange={handleNewImageChanged}
            style={{ display: "none" }}
          />
          <label
            className="new-project-hotspot-pannellum-materials-content-scenes__upload"
            htmlFor="new-project-hotspot-pannellum-materials-uploader"
          >
            {!newImage
              ? availableImages.length === 0
                ? "Upload a new panorama to use"
                : "Or upload a new panorama to use"
              : "Change image"}
          </label>
          {newImage && (
            <img
              className="new-project-hotspot-pannellum-materials-content-scenes__new-image"
              src={URL.createObjectURL(newImage)}
            />
          )}
        </div>
      );
    }

    return <></>;
  };

  return (
    <div className="new-project-hotspot-pannellum-materials">
      <div className="new-project-hotspot-pannellum-materials-content">
        {getRender()}
      </div>
    </div>
  );
};

export default MaterialSelection;
